import { useFormState } from 'react-hook-form';
import { ButtonProps } from 'components/Button/Button.types';
import { MouseEvent, useCallback } from 'react';
import Button from 'components/Button/Button';

export type SubmitButton = ButtonProps;

const SubmitButton = ({
  disabled: disabledFromProps,
  onClick,
  ...restOfProps
}: ButtonProps) => {
  const { isSubmitting, errors, isValid } = useFormState();

  const amountOfErrors = Object.keys(errors).length;
  const isFormValid = amountOfErrors === 0 && isValid;

  const disabled = disabledFromProps || isSubmitting || !isFormValid;

  const handleClick = useCallback(
    (domEvent: MouseEvent<HTMLButtonElement>) => {
      if (isSubmitting || disabled) {
        domEvent?.preventDefault();
      }

      // In ButtonBase we have set  '&[disabled] { pointer-events: none; }'
      // but just to be more resilient we add a check here.
      if (!disabled && typeof onClick === 'function') {
        onClick(domEvent);
      }
    },
    [disabled, isSubmitting, onClick],
  );

  return (
    <Button
      {...restOfProps}
      onClick={handleClick}
      disabled={disabled}
      type="submit"
    />
  );
};
export default SubmitButton;
